export default () => ({
    user:null,//用户信息
    expectedOrientationType: 'portrait-primary', // 期望的屏幕方向（默认向上竖屏）
    currentOrientationType: 'portrait-primary', // 当前屏幕方向（默认向上竖屏）
    isIgnoreScreenOrientation: true // 是否忽略屏幕方向
  })